/** Maps each menu option `code` (as received from the API, UPPERCASE) to its Bootstrap Icon class.
 *  Keys match the API contract exactly → no runtime transformation needed.
 *  Add a new entry here whenever the API introduces a new menu code. */
export const MENU_ICONS: Record<string, string> = {
    LANDPAGE:                   'bi-columns-gap',
    HOME:                       'bi-house',
    SEARCH_APPLICATIONS:        'bi-search',
    NEW_APPLICATION:            'bi-file-earmark-plus',
    PLANNING_REPLIES:           'bi-search',
    AI_VALIDATOR:               'bi-cpu',
    AI_VALIDATOR_CONFIGURATION: 'bi-sliders',
    AI_VALIDATOR_DASHBOARD:     'bi-bar-chart-line',
    MANAGE_TEAM_ALLOCATIONS:    'bi-people',
    PLANNING_SUBMISSIONS:       'bi-file-earmark-arrow-up',
    MANAGE_TEMPLATE_TYPES:      'bi-layout-text-window',
    MANAGE_TEMPLATE_DOCUMENTS:  'bi-file-earmark-richtext',
    MANAGE_COMMON_STANDARD_CODES: 'bi-code-square',
    MANAGE_STANDARD_CODES:        'bi-code-square',
    MANAGE_PUBLIC_USERS:          'bi-people',
    MANAGE_ADMIN_USERS: 'bi-person-fill-gear',
    SYSTEM_AUDIT: 'bi-person-workspace',
    MY_INSPECTIONS:             'bi-clipboard-check',
    MY_WORKLOAD:                'bi-kanban',
    MY_ACTIONS:                 'bi-check2-square',
    SEARCH_BY_MAP:              'bi-map',
    REPORTS:                    'bi-file-earmark-text',
    MY_REPORTS:                 'bi-file-earmark-person',
    REPORTS_CONNECTIONS:         'bi-database-gear',
    REPORTS_CONFIGURATION:       'bi-gear-wide-connected',
    TEMPLATE_CATEGORIES:         'bi-file-earmark',
    MANAGE_CONTACTS:              'bi-people',
    MANAGE_CALENDAR:              'bi-calendar3',
    SIGN_IN:                    'bi-box-arrow-in-right',
    SIGN_OUT: 'bi-box-arrow-right',
    SEARCH_BY_DISTRICT: 'bi-search',
    MENU_CONFIGURATOR_IMPORTER: 'bi-file-earmark-arrow-up',
    MENU_CONFIGURE_SERVICE_CONFIGURATOR: 'bi-sliders',
    MENU_TEMPLATES_CONFIGURATOR: 'bi-file-earmark',
    MENU_MANAGE_USERS: 'bi-people',
    MENU_VALIDATE_SHAREPOINT: 'bi-ui-checks',
    MENU_CLIENT_FILES: 'bi-file-earmark-person',
    MENU_IMPORT_TRANSLATION: 'bi-translate',
    MENU_EXPORT_TRANSLATION: 'bi-translate',
    MENU_ADD_VALIDATOR_USERS: 'bi-person-add',
    BATCHES: 'bi-gear',
    EVENTS: 'bi-gear',
    CONFIGURE_HMLR_RULES: 'bi-gear',
    HMLR_MAINTENANCE: 'bi-gear',
    HMLR_REGISTER_AUDIT: 'bi-gear',
    RECENT_APPLICATIONS: 'bi-clock-history',
} as const;
